<template>
<div class="form-container">
  <!-- <tl-header type="h2"></tl-header> -->
  <form action class="form">
    <div class="inputContainer" v-for="(field, index) in fields" :key="index">
      <span class="inputLabel">{{ field.label }}</span>
      <input type="text" :placeholder="'Enter ' + [[ field.label ]]" v-model="record[field.key]" autofocus>
    </div>
  </form><br><br>
  <btn-grp>
    <btn text="Cancel" type="secondary" v-on:click="$emit('cancel')"></btn>
    <btn text="Update" type="primary" v-on:click="updateRecord"></btn>
  </btn-grp>
</div>
</template>

<script>
export default {
  name: 'Form',
  props: {
    'fields': {
      type: Array
    },
    'data': {
      type: Object
    }
  },
  data() {
    return {
      record: this.data
    }
  },
  mounted: function() {
    this.record = this.$_.cloneDeep(this.data);
  },
  methods: {
    updateRecord() {
      this.$emit('save', this.record);
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/scss/components/form.scss";
</style>
